import React, { useEffect, useState } from 'react'
import styles from './LoginPage.module.css'; // Make sure to create and style this CSS file accordingly
import TextInput from '../components/UI/TextInput';
import Button from '../components/UI/Button';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import ErrorCard from '../components/UI/ErrorCard';
import { MdOutlineKeyboardBackspace } from 'react-icons/md';

const LoginPage = props => {

    const [errorText, setErrorText] = useState('');
    const [emailInput, setEmailInput] = useState('');
    const [passwordInput, setPasswordInput] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const signIn = async () => {
        if (emailInput.length === 0 || passwordInput.length === 0) {
            setErrorText("All fields are required")
            return false;
        }
        try {
            setIsLoading(true)
            await signInWithEmailAndPassword(getAuth(), emailInput.trim(), passwordInput.trim());
        } catch (e) {
            setErrorText(`Login error: ${e.code}`);
            return false;
        } finally {
            setIsLoading(false)
        }
        return true;
    }

    useEffect(() => {
        setErrorText('');
    }, [emailInput, passwordInput])

    return (
        <div className={styles.login_page}>
            <div className={styles.login_left}>
                <img src={require('../assets/images/logo-black.png')} alt="logo" className={styles.logo_img} />
                <span className={styles.title}>Sign in to your account</span>
                <TextInput type="text" label="Email" wrapperClassNames={styles.login_input} value={emailInput} setValue={setEmailInput} />
                <TextInput type="password" label="Password" wrapperClassNames={styles.login_input} value={passwordInput} setValue={setPasswordInput} />
                {errorText && <ErrorCard wrapperClassName={styles.error_card} errorText={errorText} />}
                <Button text="Sign In" wrapperClassName={styles.login_button} onClick={signIn} isLoading={isLoading} />
            </div>
            <div className={styles.login_right}>
                <div className={styles.background_image}>
                    <div className={styles.back_button} onClick={() => window.location.href="https://www.echoagent.io"}>
                        <MdOutlineKeyboardBackspace style={{ marginRight: '5px' }} />
                        Back to website
                    </div>
                    <div className={styles.card}>
                        <span>No account? No worries.</span>
                        <p>
                            Book a quick demo call, and we’ll walk you through how everything works. Once you’re onboarded, you’ll gain instant access to your account and enjoy a 1-month free trial to get you started.
                        </p>
                        <a href="https://calendly.com/echoagent/demo" target='_blank'>Click here to book a meeting</a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;